// extracted by mini-css-extract-plugin
export default {"slideContaniner":"index_slideContaniner_u05FP","dot":"index_dot_BS5tI","current":"index_current_1h85K","slideItem":"index_slideItem_JWyoS","innerText":"index_innerText_8ihVi"};